import React, { useEffect, useState } from "react";
import api from "../lib/api";
import ContentRow from "../components/ContentRow";
import { Users } from "lucide-react";

export default function Family() {
  const [videos, setVideos] = useState([]);
  useEffect(() => { api.get("/family/videos").then((r) => setVideos(r.data || [])).catch(() => {}); }, []);

  return (
    <div data-testid="family-page" className="min-h-screen pt-32 pb-20">
      <section className="px-3 sm:px-6 md:px-10">
        <div className="relative max-w-6xl mx-auto rounded-2xl md:rounded-3xl overflow-hidden p-8 md:p-12 bg-gradient-to-br from-[#0a3d2e] via-[#0f5c44] to-[#12a570]">
          <div className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-center">
            <img
              src="/tapintv-kids-logo.png"
              alt="Tap IN Kids Network"
              data-testid="family-kids-logo"
              className="pointer-events-none select-none w-36 sm:w-44 md:w-52 mx-auto md:mx-0 drop-shadow-[0_0_30px_rgba(255,255,255,0.25)]"
            />
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Users className="w-6 h-6 text-emerald-200" />
                <div className="text-xs uppercase tracking-[0.3em] text-emerald-100 font-bold">Family Channel</div>
              </div>
              <h1 className="font-display font-black text-4xl sm:text-5xl md:text-6xl text-white tracking-tighter leading-[1.05]">
                The best of Tap In Kids,<br />for the whole family.
              </h1>
              <p className="mt-4 text-white/85 max-w-xl">
                Hand-picked kid creations approved for the main network. Gather the family and enjoy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="mt-6">
        <ContentRow title="Featured this week" items={videos} variant="wide" testId="row-family-featured" />
        {videos.length === 0 && (
          <div data-testid="family-empty" className="text-center text-white/60 mt-10">
            Featured family content coming soon.
          </div>
        )}
      </div>
    </div>
  );
}
